import { render } from "./TextbookList.vue?vue&type=template&id=5aa58126"
import script from "./TextbookList.vue?vue&type=script&lang=js"
export * from "./TextbookList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Terms/TextbookList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5aa58126"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5aa58126', __exports__)) {
    api.reload('5aa58126', __exports__)
  }
  
  module.hot.accept("./TextbookList.vue?vue&type=template&id=5aa58126", () => {
    api.rerender('5aa58126', render)
  })

}


export default __exports__